import React from 'react';
import { useTranslation } from 'react-i18next';

export const useStatusCustomization = () => {
  const { t: translate } = useTranslation();

  return {
    Pending: (
      <p style={{ color: 'rgba(241, 180, 76, 1)', margin: '0 0' }}>{translate('Pending')}</p>
    ),
    Activated: (
      <p style={{ color: 'rgba(52, 195, 143, 1)', margin: '0 0' }}>{translate('Activated')}</p>
    ),
    Deactivated: (
      <p style={{ color: 'rgba(244, 106, 106, 1)', margin: '0 0' }}>{translate('Deactivated')}</p>
    ),
  };
};
